import { GoogleGenerativeAI } from '@google/generative-ai';

function patchOrAppendChatSections(prevChats, newObj, keysToAdd) {
    // If no chatSections yet, create the first element
    if (prevChats.length === 0) {
        localStorage.setItem('isEnabled', false);
        return [newObj];
    }
    let isEnabled = localStorage.getItem('isEnabled');
    // If localStorage 'isEnabled' is true => create new element
    if (isEnabled === 'true') {
        // console.log('patch prevChats', prevChats);
        const updated = [...prevChats];
        // console.log('patch updated', updated);
        updated.push(newObj);
        // console.log('patch updated', updated);
        localStorage.setItem('isEnabled', false);
        return updated;
    }
    // Otherwise, patch the last element in the array
    const updated = [...prevChats];
    // console.log('patch [...prevChats]', [...prevChats]);
    // console.log('patch updated', updated);
    const lastIndex = updated.length - 1;
    // console.log('patch lastIndex', lastIndex);
    const lastElem = updated[lastIndex];
    // console.log('patch lastElem', lastElem);
    updated[lastIndex] = { ...lastElem, ...keysToAdd };
    // console.log('patch ...lastElem', lastElem);
    // console.log('patch ...keysToAdd', keysToAdd);
    // console.log('patch updated[lastIndex]', updated[lastIndex]);
    return updated;
}

export const generateInsightsWithGemini = async (prompt, setAPIError, signal, setThinkingobj, setChatSections,
    Actor_Model_apiProvider, setActor_Model_apiProvider,
    Actor_Model_apiModel, setActor_Model_apiModel,
    Actor_Model_apikey, setActor_Model_apikey,
    temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
) => {
    while (true) {
        try {
            if (signal?.aborted) throw new Error('Gemini request aborted');
            const temperature_val = parseFloat(temperature_val_Actor_Model_apiProvider);
            const apiKey = Actor_Model_apikey;
            if (!apiKey) {
                throw new Error('GEMINI_API_KEY not found in environment variables');
            }
            setAPIError();
            const genAI = new GoogleGenerativeAI(apiKey);
            const model = genAI.getGenerativeModel({
                model: Actor_Model_apiModel,
                generationConfig: {
                    responseMimeType: "text/plain",
                    temperature: temperature_val
                }
            });
            // Use AbortController for startChat
            const controller = new AbortController();
            const abortPromise = new Promise((_, reject) => {
                signal?.addEventListener('abort', () => {
                    controller.abort();
                    reject(new Error('Gemini chat initialization aborted'));
                });
            });
            // Race startChat with abort and timeout
            const chat = await Promise.race([
                model.startChat({ signal: controller.signal }),
                new Promise((_, reject) => setTimeout(() => {
                    controller.abort();
                    reject(new Error('Gemini chat initialization timed out after 25 seconds'));
                }, 25000)),
                abortPromise
            ]);
            // Use AbortController for sendMessage
            const sendController = new AbortController();
            const sendAbortPromise = new Promise((_, reject) => {
                signal?.addEventListener('abort', () => {
                    sendController.abort();
                    reject(new Error('Gemini message send aborted'));
                });
            });
            // Race sendMessage with abort and timeout
            const response = await Promise.race([
                chat.sendMessage(prompt, { signal: sendController.signal }),
                new Promise((_, reject) => setTimeout(() => {
                    sendController.abort();
                    reject(new Error('Gemini message send timed out after 6 seconds'));
                }, 6000)),
                sendAbortPromise
            ]);
            return response.response.text();
        } catch (error) {
            if (error.name === 'AbortError' || error.message.includes('aborted')) {
                // console.log('Gemini request aborted');
                throw new Error('Gemini request aborted');
            }
            setAPIError && setAPIError(error.message);
            // Wait 2 seconds before retrying
            await new Promise((resolve) => setTimeout(resolve, 2000));
        }
    }
};

export const evaluateWithDeepSeek = async (prompt, setAPIError, signal, setThinkingobj, setChatSections,
    Actor_Model_apiProvider, setActor_Model_apiProvider,
    // Critic_Model_apiProvider, setCritic_Model_apiProvider,
    Actor_Model_apiModel, setActor_Model_apiModel,
    // Critic_Model_apiModel, setCritic_Model_apiModel,
    Actor_Model_apikey, setActor_Model_apikey,
    // Critic_Model_apikey, setCritic_Model_apikey,
    temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
    // temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
) => {
    // Set up a periodic GET request that runs every 4 seconds
    let pingIntervalId = null;
    // Start the periodic ping
    const startPing = () => {
        pingIntervalId = setInterval(async () => {
            try {
                setThinkingobj((prevState) => {
                    const newObj = { ...prevState, error: false, loading: true, timout_err: false };
                    setChatSections((prev) => {
                        return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: false });
                    });
                    return newObj;
                });
                // Simple GET request to jsonplaceholder API
                const response = await fetch('https://jsonplaceholder.typicode.com/posts/1');

                if (!response.ok) {
                    // console.log('Periodic ping request failed with status:', response.status);
                } else {
                    const json = await response.json();
                    // console.log(json);
                }
            } catch (pingError) {
                setThinkingobj((prevState) => {
                    const newObj = { ...prevState, error: false, loading: true, timout_err: true };
                    setChatSections((prev) => {
                        return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: true });
                    });
                    return newObj;
                });
                // console.log('Periodic ping request error:', pingError.message);
            }
        }, 6000); // Run every 6 seconds
    };
    // Clear the ping interval when done
    const stopPing = () => {
        if (pingIntervalId) {
            clearInterval(pingIntervalId);
            pingIntervalId = null;
        }
    };
    // Start the ping immediately
    startPing();
    try {
        while (true) {
            try {
                if (signal?.aborted) throw new Error('DeepSeek request aborted');
                const temperature_val = parseFloat(temperature_val_Actor_Model_apiProvider);
                const apiKey = Actor_Model_apikey;
                if (!apiKey) {
                    throw new Error('DEEPSEEK_API_KEY not found in environment variables');
                }
                setAPIError();
                // Create a new AbortController that we'll use for our fetch request
                const controller = new AbortController();
                // Set up a timeout that will abort the controller after 15 seconds
                const timeoutId = setTimeout(() => {
                    controller.abort();
                }, 15000);
                // If the parent signal aborts, we should abort our controller too
                if (signal) {
                    signal.addEventListener('abort', () => {
                        controller.abort();
                    });
                }
                try {
                    // Make the request with our controller's signal
                    const response = await fetch('https://api.deepseek.com/v1/chat/completions', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${apiKey}`,
                        },
                        body: JSON.stringify({
                            model: Actor_Model_apiModel,
                            messages: [{ role: "user", content: prompt }],
                            temperature: temperature_val,
                            max_tokens: 4000
                        }),
                        signal: controller.signal
                    });
                    // Clear the timeout since request completed
                    clearTimeout(timeoutId);
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Failed to get response from DeepSeek');
                    }

                    const data = await response.json();
                    stopPing(); // Stop the ping before returning
                    return data.choices[0].message.content;
                } catch (fetchError) {
                    // Re-throw the error to be caught by the outer try-catch
                    throw fetchError;
                } finally {
                    // Ensure the timeout is cleared
                    clearTimeout(timeoutId);
                }
            } catch (error) {
                // Handle aborted requests specially
                // console.log('DeepSeek request error57:', error, error?.message);
                if (error.name === 'AbortError' || error.message.includes('aborted')) {
                    // console.log('DeepSeek request aborted');

                    // Check if it was our timeout or an explicit abort
                    if (error.message.includes('timed out')) {
                        setAPIError && setAPIError('DeepSeek request timed out after 15 seconds');
                    } else {
                        // It was explicitly aborted, so stop the ping and throw
                        stopPing();
                        throw new Error('DeepSeek request aborted');
                    }
                }
                // Wait 2 seconds before retrying
                await new Promise((resolve) => setTimeout(resolve, 2000));
            }
        }
    } finally {
        // Ensure the ping is stopped if the function exits for any reason
        stopPing();
    }
};

export const generateInsightsWithClaude = async (prompt, setAPIError, signal, setThinkingobj, setChatSections,
    Actor_Model_apiProvider, setActor_Model_apiProvider,
    Actor_Model_apiModel, setActor_Model_apiModel,
    Actor_Model_apikey, setActor_Model_apikey,
    temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
) => {
    // Set up a periodic GET request that runs every 6 seconds
    var pingError = false;
    let pingIntervalId = null;

    // Start the periodic ping
    const startPing = () => {
        pingIntervalId = setInterval(async () => {
            try {
                setThinkingobj((prevState) => {
                    const newObj = { ...prevState, error: false, loading: true, timout_err: true };
                    setChatSections((prev) => {
                        return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: false });
                    });
                    return newObj;
                });
                pingError = false
                // Simple GET request to jsonplaceholder API
                const response = await fetch('https://jsonplaceholder.typicode.com/posts/1');
                if (!response.ok) {
                    // console.log('Anthropic Periodic ping request failed with status:', response.status);
                    pingError = true; // Set flag for connection issues

                    setThinkingobj((prevState) => {
                        const newObj = { ...prevState, error: false, loading: true, timout_err: true };
                        setChatSections((prev) => {
                            return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: true });
                        });
                        return newObj;
                    });
                    throw new Error('Network connection issue detected')
                } else {
                    // Reset ping error flag on successful ping
                    pingError = false;
                    const json = await response.json();
                    // console.log(json);
                    setThinkingobj((prevState) => {
                        const newObj = { ...prevState, error: false, loading: true, timout_err: false };
                        setChatSections((prev) => {
                            return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: false });
                        });
                        return newObj;
                    });
                }
            } catch (error) {
                // console.log('Anthropic Periodic ping request error:', error);
                pingError = true; // Set flag instead of throwing
                setThinkingobj((prevState) => {
                    const newObj = { ...prevState, error: false, loading: true, timout_err: true };
                    setChatSections((prev) => {
                        return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: true });
                    });
                    return newObj;
                });

                // Don't throw here - it won't propagate outside the interval callback
                // Instead, we're setting the pingError flag to true
            }
        }, 6000); // Run every 6 seconds
    };
    // Clear the ping interval when done
    const stopPing = () => {
        if (pingIntervalId) {
            clearInterval(pingIntervalId);
            pingIntervalId = null;
        }
    };
    // Start the ping immediately
    startPing();
    try {
        while (true) {
            try {
                if (signal?.aborted) {
                    throw new Error('Anthropic Claude request aborted');
                }
                const temperature_val = temperature_val_Actor_Model_apiProvider
                const apiKey = Actor_Model_apikey
                setThinkingobj((prevState) => {
                    const newObj = { ...prevState, error: false, loading: true, timout_err: false };
                    setChatSections((prev) => {
                        return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: false });
                    });
                    return newObj;
                });
                if (!apiKey) {
                    throw new Error('CLAUDE_API_KEY not found in environment variables');
                }
                setAPIError();
                // Create a new AbortController that we'll use for our fetch request
                const controller = new AbortController();

                // Set up a timeout that will abort the controller after 15 seconds
                const timeoutId = setTimeout(() => {
                    controller.abort();
                }, 15000);

                // If the parent signal aborts, we should abort our controller too
                if (signal) {
                    signal.addEventListener('abort', () => {
                        controller.abort();
                    });
                }
                try {
                    while (true) {
                        try {
                            // Check if ping error exists before making Claude API call
                            if (pingError) {
                                throw new Error('Network connection issue detected');
                            }
                            setThinkingobj((prevState) => {
                                const newObj = { ...prevState, error: false, loading: true, timout_err: false };
                                setChatSections((prev) => {
                                    return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: false });
                                });
                                return newObj;
                            });
                            // Make the request with our controller's signal
                            const response = await fetch('https://claude-api-proxy-server.onrender.com/api/claude-proxy', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-api-key': apiKey,
                                    'anthropic-version': '2023-06-01'
                                },
                                body: JSON.stringify({
                                    model: Actor_Model_apiModel,
                                    messages: [{ role: "user", content: prompt }],
                                    temperature: temperature_val,
                                    max_tokens: 4000
                                }),
                                signal: controller.signal
                            });
                            // If successful, process and return the data
                            if (response.ok) {
                                const data = await response.json();
                                stopPing(); // Stop the ping before returning
                                return data.content;
                            }
                            // If we get here, the response wasn't ok
                            const errorData = await response.json();
                            throw new Error(errorData.error?.message || 'Failed to get response from Claude');
                        } catch (apiError) {
                            // Check if the operation was aborted
                            if (apiError.name === 'AbortError' || apiError.message.includes('aborted')) {
                                // console.log('Anthropic Claude request aborted apiError:', apiError);
                                throw apiError; // Don't retry aborted requests
                            }
                            setThinkingobj((prevState) => {
                                const newObj = { ...prevState, error: false, loading: true, timout_err: true };
                                setChatSections((prev) => {
                                    return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: true });
                                });
                                return newObj;
                            });
                            setAPIError && setAPIError(`Claude API call failed...`);
                            // console.log('Anthropic Claude API error:', apiError);
                            // If we've reached max retries, rethrow the error
                            throw apiError;
                            // Wait before retry
                            await new Promise(resolve => setTimeout(resolve, 2000));
                        }
                    }
                } catch (fetchError) {
                    // Re-throw the error to be caught by the outer try-catch
                    // console.log('Anthropic Claude request error:', fetchError);
                    throw fetchError;
                } finally {
                    // Ensure the timeout is cleared
                    clearTimeout(timeoutId);
                }
            } catch (error) {
                // Handle various error conditions
                // console.log('** ## Anthropic Claude request error:', error?.message);

                // Check for ping errors
                if (pingError) {
                    // console.log('Network connection issue detected');
                    setAPIError && setAPIError('Network connection issue detected, retrying in 2 seconds');
                    setThinkingobj((prevState) => {
                        const newObj = { ...prevState, error: false, loading: true, timout_err: true };
                        setChatSections((prev) => {
                            return patchOrAppendChatSections(prev, newObj, { error: false, loading: true, timout_err: true });
                        });
                        return newObj;
                    });
                    // Wait before retrying
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                    continue;
                }
                if (pingError && error?.message === 'Network connection issue detected' && error?.message === 'Anthropic Claude request aborted') {
                    // console.log('Anthropic Claude request aborted');
                    setAPIError && setAPIError('Anthropic Claude request timed out after 15 seconds');
                    setThinkingobj((prevState) => {
                        const newObj = { ...prevState, error: true, loading: false, timout_err: false };
                        setChatSections((prev) => {
                            return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
                        });
                        return newObj;
                    });
                    stopPing();
                    throw new Error('Anthropic Claude request aborted');
                }

                // Handle aborted requests
                if (error?.message === 'signal is aborted without reason' ||
                    error?.message === 'Anthropic Claude request aborted') {
                    // console.log('Anthropic Claude request aborted');
                    setAPIError && setAPIError('Anthropic Claude request timed out after 15 seconds');
                    setThinkingobj((prevState) => {
                        const newObj = { ...prevState, error: true, loading: false, timout_err: false };
                        setChatSections((prev) => {
                            return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
                        });
                        return newObj;
                    });
                    stopPing();
                    throw new Error('Anthropic Claude request aborted');
                }

                // For other errors, wait and retry
                await new Promise((resolve) => setTimeout(resolve, 2000));
            }
        }
    } finally {
        // Ensure the ping is stopped if the function exits for any reason
        // console.log('Anthropic Claude request completed or aborted');
        stopPing();
    }
};